import { Box, Typography, Paper, Divider } from '@mui/material';
import { StepFeedback, StepFeedbackType } from './StepFeedback';

interface WizardStepProps {
  stepNumber: number;
  totalSteps: number;
  title: string;
  description?: string;
  feedback?: { type: StepFeedbackType; title?: string; messages: string[] } | null;
  children: React.ReactNode;
}

export const WizardStep = ({
  stepNumber,
  totalSteps,
  title,
  description,
  feedback,
  children,
}: WizardStepProps) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle1" fontWeight={700}>
          Step {stepNumber} of {totalSteps}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {title}
        </Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />

      <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>
      )}

      {feedback && (
        <StepFeedback
          type={feedback.type}
          title={feedback.title}
          messages={feedback.messages}
        />
      )}

      <Box>{children}</Box>
    </Paper>
  );
};